import { getFetch, postFetchWithBody } from "../../utils/fetch";

async function getReportDatas() {
  const data = await getFetch("/ReportWeb");
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

async function getReportImages(id) {
  const data = await getFetch(`/ReportWeb/Reports/show?id=${id}`);
  if (data.status !== "error") {
    return {
      status: "success",
      message: data,
    };
  } else {
    return {
      status: data.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

async function getJensList(page,term = ""){
  const data = await getFetch(`/Jens?page=${page}&term=${term}`)
  if(data.status !== "error"){
    return {
      status: "success",
      message: data
    }
  }else{
    return {
      status: data.status,
      message: 'خطا در اتصال به سرور!'
    }
  }
}
async function deleteJens(id) {
  const res = await postFetchWithBody(`/Jens/delete`, { id: id });
  if (res.status !== "error") {
    return {
      status: "success",
      message: res,
    };
  } else {
    return {
      status: res.status,
      message: "خطا در اتصال به سرور!",
    };
  }
}

export { getReportDatas, getReportImages , getJensList,deleteJens};
